import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { NA_VALUE, UNIQUE_SIZE } from '@yme/common/constants';
import { FrameSizeWidget } from '@yme/molecules/framesize-widget';
import { setFilterOptions, getProductCardLabels, getProductValueByOption, } from '@yme/pdp-components/ProductCard';
import { SIZE_KEY } from '@yme/selectors/constants';
import { getCommon, getRootLang } from '@yme/selectors/index';
import { getProductVariantsByColor } from '@yme/selectors/products';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { SelectSize } from '../SelectSize';
import { useSelectNewValue } from '../useSelectNewValue';
import { adaptLangValue, getFrameSizesValue } from './helpers';
export function SelectFrameSize({ productFilterOptions, variantsOfProduct, currentProduct, smartfitKey, }) {
    const allProductSizeValues = useSelector(getProductValueByOption(SIZE_KEY));
    const productVariantsByColor = useSelector(getProductVariantsByColor);
    const productCardLabels = useSelector(getProductCardLabels);
    const language = useSelector(getRootLang);
    const { ecommerceId } = useSelector(getCommon);
    const dispatch = useDispatch();
    const history = useHistory();
    const lang = adaptLangValue(language);
    const { size, sku, colorItemIndex = 0 } = productFilterOptions;
    const { selectNewValue } = useSelectNewValue({
        size,
        sku,
        variantsOfProduct,
    });
    const productVariantsByIndex = productVariantsByColor[colorItemIndex];
    const possibleOptions = productVariantsByColor && productVariantsByIndex?.sizePossibleOptions
        ? productVariantsByIndex.sizePossibleOptions
        : allProductSizeValues;
    const formattedAllProductSizeValues = getFrameSizesValue(allProductSizeValues, productCardLabels);
    const formattedPossibleOptions = getFrameSizesValue(possibleOptions, productCardLabels);
    /*
     * this click intercepts the event from the widget window
     * to set the new url and filter parameters (frame size)
     */
    const onClickHandler = useCallback((opt) => {
        if (opt?.sku && opt?.size) {
            history.push({
                hash: opt.sku,
            });
            dispatch(setFilterOptions({
                sku: opt.sku,
                size: opt.size,
            }));
        }
    }, [dispatch, history]);
    const isSelectSizeFeatureVisible = formattedAllProductSizeValues.some((item) => {
        return Boolean(item.value !== NA_VALUE && item.value !== UNIQUE_SIZE && item.value.trim() !== '');
    });
    return isSelectSizeFeatureVisible ? (React.createElement(SelectSize, { productFilterOptions: productFilterOptions, variantsOfProduct: variantsOfProduct, allOptions: formattedAllProductSizeValues, possibleOptions: formattedPossibleOptions, allProductSizeValues: allProductSizeValues, productVariantsByColor: productVariantsByColor, onSelectNewValue: selectNewValue, isRadioVisible: true },
        React.createElement(RegularTextLevel3, { weight: 500 }, productCardLabels?.productCard_frameSize_label),
        React.createElement(FrameSizeWidget, { sku: sku, images: productVariantsByIndex.images, productName: currentProduct.productName, lang: lang, smartfitKey: smartfitKey, linkLabel: productCardLabels?.productCard_viewSizeGuide_link, slug: ecommerceId?.slug, onClickHandler: onClickHandler }))) : null;
}
SelectFrameSize.displayName = 'SelectFrameSize_Component';
